import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/styles';
import { Box, Typography } from '@material-ui/core';

import { DE, DOMAIN_LANGUAGE, NL } from '../../../constants/browser';
import { getPhoto } from '../../../utils/images';
import { Avatar, Translation } from '../../common';

const NAMES = { [NL]: 'Daniela Straube', [DE]: 'Philip Rürup' };

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexShrink: 0
  },
  rootSmall: {
    flexDirection: 'row'
  },
  rootNoLogo: {
    margin: 'auto'
  },
  rootNoLogoTablet: {
    marginBottom: 24
  },
  avatar: {
    width: 128,
    height: 128
  },
  avatarSmall: {
    width: 80,
    height: 80
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 8
  },
  name: {
    ...theme.typography.body1Bold,
    margin: '8px 0 0 0',
    color: theme.palette.text.primary,
    textAlign: 'center'
  },
  nameSmall: {
    ...theme.typography.body2Bold,
    margin: '0 0 8px 0',
    textAlign: 'left'
  },
  descriptionSmall: {
    maxWidth: 86,
    fontSize: '0.5625rem',
    lineHeight: 1.333333
  }
}));

const GreetingAvatar = ({
  logoMissing,
  isTabletSize,
  isMobileSize,
  className
}) => {
  const classes = useStyles();
  const isCompact = isTabletSize || isMobileSize;

  const name = NAMES[DOMAIN_LANGUAGE] || NAMES[DE];
  const picture = getPhoto(DOMAIN_LANGUAGE) || getPhoto(DE);

  const descriptionKey =
    isMobileSize && !logoMissing ? 'TROY_DIRECTOR_ON_BEHALF' : 'TROY_DIRECTOR';

  return (
    <div
      className={classNames(
        classes.root,
        isCompact && classes.rootSmall,
        logoMissing && classes.rootNoLogo,
        isTabletSize && logoMissing && classes.rootNoLogoTablet,
        className
      )}
    >
      <Avatar
        alt="avatar"
        src={picture}
        className={classNames(classes.avatar, isCompact && classes.avatarSmall)}
      />
      <Box className={classNames(isCompact && classes.details)}>
        <Typography
          variant="body1"
          component="h4"
          className={classNames(classes.name, isCompact && classes.nameSmall)}
        >
          {name}
        </Typography>
        <Typography
          className={classNames(
            !logoMissing && isMobileSize && classes.descriptionSmall
          )}
          variant={isCompact ? 'subtitle1' : 'body2'}
          component="h5"
          color="textPrimary"
        >
          <Translation inline keyIfNoValue>
            {descriptionKey}
          </Translation>
        </Typography>
      </Box>
    </div>
  );
};

GreetingAvatar.propTypes = {
  logoMissing: PropTypes.bool,
  isTabletSize: PropTypes.bool,
  isMobileSize: PropTypes.bool,
  className: PropTypes.string
};

export default GreetingAvatar;
